import { Helmet } from "react-helmet-async";
import { useTranslation } from "react-i18next";

const SITE = "MARDATIQ";
const BASE = "https://mardatiq.com";

export function Seo({
  title,
  description,
  path = "/",
  type = "website",
  jsonLd,
  image,
}) {
  const { i18n } = useTranslation();
  const fullTitle = title ? `${title} · ${SITE}` : `${SITE} — Market clarity in 30 seconds`;
  const url = `${BASE}${path}`;
  const desc =
    description ||
    "Live prices, transparent trend signals and practical calculators for gold, Bitcoin, oil and major currencies.";

  return (
    <Helmet htmlAttributes={{ lang: i18n.language }}>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      <link rel="canonical" href={url} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={SITE} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content={image ? "summary_large_image" : "summary"} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      {jsonLd && (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      )}
    </Helmet>
  );
}




